<template>
    <footer>Copyright<img src="@/assets/images/logo_pixnet_footer.svg" alt="痞客邦" loading="lazy" /> © 2003 - 2023                     優像數位媒體科技 ( 股 ) 公司</footer>
</template>

<style lang="scss" scoped>
@import '@/styles/theFooter';
</style>
